import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Safely extracts a human-readable error message from any axios error.
 * Handles FastAPI 422 detail arrays (objects with type/loc/msg) which crash React if rendered directly.
 */
export const extractApiError = (err, fallback = "Something went wrong.") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    if (typeof first === "string") return first;
    if (first?.msg) return first.msg;
  }
  if (err?.message && typeof err.message === "string") return err.message;
  return fallback;
};

export default api;
